import { RootState } from 'MyTypes';

export const getAnnouncements = ({ resources }: RootState) => resources.announcements;
export const getSidebarLinks = ({ resources }: RootState) => resources.sidebarLinks;
